import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require('jszip');
require('datatables.net-buttons/js/buttons.html5.min');
window.JSZip = jzip;

require('datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class PatientStats extends Component {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.excelStats = this.excelStats.bind(this);
		this.pdfStats = this.pdfStats.bind(this);

		this.state = {
			start_date: "",
			end_date: "",
			listado: [],
			columns: [
				{ title: 'Grupo Sanguíneo' },
				{ title: 'Hombres' },
				{ title: '%' },
				{ title: 'Mujeres' },
				{ title: '%' },
				{ title: 'Sexo desconocido' },
				{ title: '%' },
				{ title: 'Total' },
				{ title: '%' }
			],
			filename: "Estadísticas de Pacientes",
			date_hour: "",
			medical: "",
			health_services: "all"
		};
	}

	componentWillMount() {
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical: (medical.lastname1 !== null ? medical.lastname1 : "") + ' ' +
				(medical.lastname2 !== null ? medical.lastname2 : "") + ' ' + medical.names
		});

		if (!this.props.hiddeToReport) {
			this.props.reload();
		}
	}

	componentDidMount() {
		this.props.waiting.handleShow('Cargando...');
		setTimeout(() => {
			this.props.waiting.handleClose();
		}, 300);

		fetch(Config.default.apiGateway.URL + 'offers?option=date', {
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
			.then(response => response.json())
			.then(response => {
				var aux = response.split('|');
				var hours = this.getHourFormat(aux[1]);
				var date = aux[0].split("/");

				this.setState({
					date_hour: aux[0] + ' ' + hours,
					start_date: date[2] + '-' + date[1] + '-' + date[0],
					end_date: date[2] + '-' + date[1] + '-' + date[0],
				});
			});
		this.setTable()
	}

	getHourFormat(hr) {
		var format = hr.split(' ');
		var hrs = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1] + ' ' + format[2];
		var hour = parseInt(hrs[0], 10);
		var minute = parseInt(hrs[1], 10);

		if ((ampm === "PM" || ampm === "p. m.") && hour < 12) hour += 12;
		if ((ampm === "AM" || ampm === "a. m.") && hour === 12) hour -= 12;

		if (hour < 10) hour = '0' + hour;
		if (minute < 10) minute = '0' + minute;

		return hour + ':' + minute;
	}

	setTable() {
		var fechas = "Del: " + moment(this.state.start_date).format("DD/MM/YYYY") +
			" Al: " + moment(this.state.end_date).format("DD/MM/YYYY")

		if (!this.el) return;

		this.$el = $(this.el);

		try {
			if ($.fn.DataTable.isDataTable(this.el)) {
				this.$el.DataTable().clear().destroy();
			}
			this.$el.empty();
		} catch (error) {
		}

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				// 'excel',
				// 'csv'
			],
			data: this.state.listado,
			// columns: this.state.columns,
			   columns: [
						{ title: 'Grupo Sanguíneo', width: '13%', className: 'dt-head-left' },
						{ title: 'Hombres', width: '12%', className: 'dt-head-center' },
						{ title: '%', width: '6%', className: 'dt-head-left' },
						{ title: 'Mujeres', width: '12%', className: 'dt-head-left' },
						{ title: '%', width: '9%', className: 'dt-head-left' },
						{ title: 'Sexo desconocido', width: '10%', className: 'dt-head-left' },
						{ title: '%', width: '8%', className: 'dt-head-left' },
						{ title: 'Total', width: '11%', className: 'dt-head-left' },
						{ title: '%', width: '10%', className: 'dt-head-left' }
					],
			columnDefs: [
				// {
				// 	targets: '_all',
				// 	 className: 'dt-body-center'
				// }
				{
            targets: [], // Primera columna alineada a la izquierda
            className: 'dt-body-left'
        },
        {
            targets: [0,1,2, 3, 4], // Resto centradas
            className: 'dt-body-center'
        },
		 {
            targets: [5,6,7,8], // Resto centradas
            className: 'dt-body-right'
        }
			],
			oLanguage: {
				"sProcessing": "Procesando...",
				"sZeroRecords": "No se encontraron resultados",
				"sEmptyTable": "Ningún dato disponible en esta tabla",
				"sInfoPostFix": "",
				"sSearch": "Buscar:",
				"sUrl": "",
				"sInfoThousands": ",",
				"sLoadingRecords": "Cargando...",
				"fnInfoCallback": null,
			},
            paging: false,
            responsive: false,
            searching: false,
            scrollY: "32em",
            scrollX: false,
            autoWidth: false,
            ordering: false,
            info: false,
		});

		  // Ajustar columnas después de renderizar
    setTimeout(() => {
        table.columns.adjust().draw();
    }, 50);
	 // Reajustar al cambiar tamaño de ventana
    $(window).off('resize.dataTable').on('resize.dataTable', () => {
        if (this.$el && $.fn.DataTable.isDataTable(this.el)) {
            this.$el.DataTable().columns.adjust();
        }
    });
	}

	handleChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});

		if (document.getElementById(e.target.name).className.includes('error')) {
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching() {
		if (this.isValidForm()) {
			if (this.dateCompare()) {
				this.props.waiting.handleShow('Buscando...');

				this.patientStats();
			} else {
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		} else {
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	patientStats() {
		const object = {
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			start_date: this.state.start_date,
			end_date: this.state.end_date,
		}

		fetch(Config.default.apiGateway.URL + 'reports/patient_stats', {
			method: 'post',
			body: JSON.stringify(object),
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
			.then(res => {
				this.props.waiting.handleClose();
				if (res.ok) {
					return res.json();
				} else {
					return res.text().then((msg) => {
						swal('Error', msg, 'error');
						throw new Error(msg);
					});
				}
			})
			.then(response => {
				this.props.waiting.handleShow('Cargando...');

				if (response !== undefined) {
    				let columns, list;

					columns = [
							{ title: 'Grupo Sanguíneo' },
							{ title: 'Hombres' },
							{ title: '%' },
							{ title: 'Mujeres' },
							{ title: '%' },
							{ title: 'Sexo desconocido' },
							{ title: '%' },
							{ title: 'Total' },
							{ title: '%' }
						];

					list = response.map(r => [
						r.Grupo && r.Grupo.trim() !== "" ? r.Grupo : "Sin grupo",
						r.Hombres,
						r.PorcentajeHombres,
						r.Mujeres,
						r.PorcentajeMujeres,
						r.SexoDesconocido,
						r.PorcentajeSexoDesconocido,
						r.Total,
						r.PorcentajeTotal
					]);

					setTimeout(() => {
						this.props.waiting.handleClose();
						this.setState({
							listado: list,
							columns: columns
						}, () => {
							this.setTable();
						});
					}, 1000);
				} else {
					swal('Error', 'No se recibieron datos válidos', 'error');
				}
			})
			.catch(error => {
				this.props.waiting.handleClose();
				console.error('Error:', error);
			});
	}

	dateCompare() {
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if (ini !== 'Invalid date' && fin !== 'Invalid date') {
			if (fin < ini) {
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			} else {
				document.getElementById('end_date').classList.remove('error');
			}
		} else {
			date_ok = false;
		}

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
		let isFormValid = true;

		inputs.forEach(input => {
			if (input.required) {
				const isInputValid = this.showCtrlError(input.name);
				if (!isInputValid) {
					isFormValid = false;
				}
			}
		});

		return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
			if (control !== null) {
				control.classList.add('error');
			}
			res = false;
		} else {
			if (control !== null) {
				if (control.required && control.className.includes('error')) {
					control.classList.remove('error');
				}
			}
			res = true;
		}
		return res;
	}

	excelStats() {
		var obj = {
			start_date: this.state.start_date,
			end_date: this.state.end_date,
			health_facilities_id: this.state.health_facilities_id
		};
		console.log(">>>", obj);
		
		this.props.waiting.handleShow('Generando Excel...');
		fetch(Config.default.apiGateway.URL + 'reports/generate_excel?report_name=patient_stats', {
			method: 'POST',
			body: JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if (res.ok) {
				return res.blob();
			} else {
				res.text().then(msg => {
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if (response !== undefined) {
				var blob = new Blob([response], { type: 'application/vnd.ms-excel' });
				var downloadUrl = URL.createObjectURL(blob);
				var a = document.createElement("a");
				a.href = downloadUrl;
				a.download = this.state.filename + '.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(downloadUrl);
			}
		});
	}

	pdfStats() {
		var fechas = "Del: " + (this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY") : '') +
			" Al: " + (this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '')

		var doc = {
			content: [
				{
					image: this.props.header_document,
					alignment: 'center',
					width: this.props.w_head
				},
				{
					text: this.state.filename, style: 'title', margin: [0, 10, 0, 12], alignment: 'center', fontSize: 15
				},
				{
					text: fechas, margin: [10, 0, 0, 10]
				},
				{
					layout: 'noBorders',
					table: {
						body: [],
						headerRows: 1,
						widths: ['16%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%']
					}
				}
			],
			defaultStyle: { fontSize: 8 },
			pageMargins: 40,
			footer: { text: this.state.date_hour + '\t-\t' + this.state.medical, alignment: 'right', margin: [0, 0, 50, 0] },
			pageOrientation: 'landscape',
			pageSize: 'A4',
			styles: {
				tableBodyEven: {},
				tableBodyOdd: { fillColor: '#f3f3f3' },
				tableHeader: { bold: true, fontSize: 8, color: 'white', fillColor: '#2d4154', alignment: 'center' }
			}
		};

		var body = [];
		var headerRow = [];
		this.state.columns.forEach((col) => {
			headerRow.push({ text: col.title, style: 'tableHeader', fillColor: '#2d4154' ,alignment: 'left'});
		});
		body.push(headerRow);

		this.state.listado.forEach((row, i) => {
			var dataRow = [];
			Object.values(row).forEach((value) => {
				dataRow.push({ text: value, style: ((i + 1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven' });
			});
			body.push(dataRow);
		});

		doc.content[3].table.body = body;

		pdfMake.createPdf(doc).download(this.state.filename + '.pdf');
	}

	render() {
		const { t } = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
						{session} {'->'} {t('sidebar.nav.reports.MAIN')} {'->'} Pacientes {'->'} {this.state.filename}
					</h5>
				</div>

				<Help
					{...this.props}
					menu={"help_patients"}
					submenu={"help_petitions_by_service_stats"} />

				<div className="form-group" style={{ paddingLeft: "0.5em" }}>
					<div className="col-xs-12"> 
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{ borderRight: "1px solid #e0e0e0" }}>
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								<div style={{ textAlign: "right" }}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{ fontSize: "1em" }}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{ marginTop: "20px", textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: '16px' }}>
										<span>{this.state.filename}</span>
									</div>
								</div>

								{this.state.listado.length > 0 &&
                                    <div className="dt-buttons" style={{float:'right'}}> 
                                        <button className="dt-button buttons-excel buttons-html5" tabIndex="0" aria-controls="table-to-xls" type="button" onClick={()=>this.excelStats()}>
                                            <span>Excel</span>
                                        </button> 
                                        <button className="dt-button buttons-pdf buttons-html5" tabIndex="0" aria-controls="table-to-xls" type="button" onClick={()=>this.pdfStats()}>
                                            <span>PDF</span>
                                        </button> 
                                    </div>
                                }

								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{ fontSize: "11px" }} id="table-to-xls" className="expenses-discards" ref={el => this.el = el}>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations')(PatientStats);
